import baseRoute from '../baseRoute';

export default `${baseRoute}/attachment` as const;
